import { inject, Injectable } from '@angular/core';
import { ApiService } from './api-service';
import { LandingPageDetail, LandingPageInput, LandingPageSummary, PagingResponse, TagFilter } from '../models/cms-models';

@Injectable({
  providedIn: 'root',
})
export class LandingPagesService {
  private apiService = inject(ApiService);

  async getSiteLandingPages(siteId: string, filter?: TagFilter): Promise<LandingPageSummary[]> {
    const response = await this.apiService.get<PagingResponse<LandingPageSummary>>(
      `api/landing-page/site/${siteId}`,
      this.buildTagQuery(filter),
    );
    return response.data;
  }

  async getLandingPage(landingPageId: string): Promise<LandingPageDetail> {
    return this.apiService.get<LandingPageDetail>(`api/landing-page/${landingPageId}`);
  }

  async createLandingPage(landingPage: LandingPageInput): Promise<LandingPageDetail> {
    return this.apiService.post<LandingPageDetail, LandingPageInput>('api/landing-page', landingPage);
  }

  async updateLandingPage(landingPageId: string, landingPage: LandingPageInput): Promise<LandingPageDetail> {
    return this.apiService.put<LandingPageDetail, LandingPageInput>(`api/landing-page/${landingPageId}`, landingPage);
  }

  async deleteLandingPage(landingPageId: string): Promise<void> {
    await this.apiService.delete(`api/landing-page/${landingPageId}`);
  }

  private buildTagQuery(filter?: TagFilter): Record<string, string | string[]> | undefined {
    if (!filter || !filter.tags.length) {
      return undefined;
    }

    return {
      tags: filter.tags,
      tagMode: filter.tagMode,
    };
  }
}
